import { render } from "./ChatTile.vue?vue&type=template&id=d6db22f6"
import script from "./ChatTile.vue?vue&type=script&lang=js"
export * from "./ChatTile.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__